import proj4 from 'proj4'

// WGS84 lat/lng -> British National Grid (OSGB36, EPSG:27700) eastings/northings.
//
// The projection definition uses a single Helmert transformation (the standard
// EPSG:27700 parameters), which is accurate to ~5m across Great Britain —
// sufficient for display, not for setting-out. Centimetre accuracy would need
// the OSTN15 correction grid.
//
// Twin: mobile has its own copy of this wrapper in
// mobile/app/components/atomic/elements/geolocation/utilities/bng.ts — keep
// the definition strings in sync.
proj4.defs(
  'EPSG:27700',
  '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 ' +
    '+ellps=airy +towgs84=446.448,-125.157,542.06,0.1502,0.247,0.8421,-20.4894 ' +
    '+units=m +no_defs',
)

const wgs84ToBng = proj4('EPSG:4326', 'EPSG:27700')
const bngToWgs84 = proj4('EPSG:27700', 'EPSG:4326')

export type EastingNorthing = { easting: number; northing: number }

export const latLngToBNG = (
  latitude: number,
  longitude: number,
): EastingNorthing => {
  const [easting, northing] = wgs84ToBng.forward([longitude, latitude])

  return {
    easting: Math.round(easting),
    northing: Math.round(northing),
  }
}

export type LatLng = { latitude: number; longitude: number }

// British National Grid (OSGB36, EPSG:27700) eastings/northings -> WGS84
// lat/lng. Inverse of latLngToBNG; same ~5m Helmert accuracy caveat applies.
export const bngToLatLng = (easting: number, northing: number): LatLng => {
  const [longitude, latitude] = bngToWgs84.forward([easting, northing])

  return { latitude, longitude }
}
